// extracted by mini-css-extract-plugin
export var formControl = "BabyMenuSearchForm-module--formControl--ca4bc";
export var searchForm = "BabyMenuSearchForm-module--searchForm--4d0a6";